import React from 'react'

const EmailVasIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={512}
                height={512}
                x={0}
                y={0}
                viewBox="0 0 490.669 490.669"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="card-svg"
            >
                <g>
                    <path
                        d="M426.668 192.003 245.335 309.336 64.001 192.003V10.669C63.876 4.903 68.449.128 74.215.003c.151-.003.302-.003.453 0h341.333c5.766-.125 10.542 4.448 10.667 10.214.003.151.003.302 0 .453v181.333z"
                        style={{}}
                        fill="#f1f2f2"
                        data-original="#f1f2f2"
                    />
                    <path
                        d="m64.001 192.003-64-42.667 64-64v106.667zM490.668 149.336l-64 42.667V85.336l64 64z"
                        style={{}}
                        fill="#f6b445"
                        data-original="#f6b445"
                    />
                    <path
                        d="m426.668 191.043 64-41.707v298.667a42.932 42.932 0 0 1-12.48 30.187l-72.853-72.853-117.334-117.334-2.987-4.587 141.654-92.373z"
                        style={{}}
                        fill="#fed049"
                        data-original="#fed049"
                        className=""
                    />
                    <path
                        d="m405.335 405.336 72.853 72.853a42.932 42.932 0 0 1-30.187 12.48H42.668a42.932 42.932 0 0 1-30.187-12.48l72.853-72.853 117.333-117.333 2.987-4.587 39.68 25.92 39.68-25.92 2.987 4.587 117.334 117.333z"
                        style={{}}
                        fill="#f6b445"
                        data-original="#f6b445"
                    />
                    <path
                        d="m205.655 283.416-2.987 4.587L85.335 405.336l-72.853 72.853a42.932 42.932 0 0 1-12.48-30.187V149.336l205.653 134.08z"
                        style={{}}
                        fill="#fed049"
                        data-original="#fed049"
                        className=""
                    />
                    <circle
                        cx="362.668"
                        cy="128.003"
                        r={128}
                        style={{}}
                        fill="#49aaee"
                        data-original="#49aaee"
                    />
                    <path
                        d="M362.668 192.003c-5.891 0-10.667-4.776-10.667-10.667v-76.075l-15.413 10.283c-4.901 3.27-11.525 1.947-14.795-2.955-3.27-4.901-1.947-11.525 2.955-14.795l32-21.333c4.9-3.27 11.524-1.947 14.793 2.953a10.668 10.668 0 0 1 1.794 5.922v96c0 5.891-4.776 10.667-10.667 10.667z"
                        style={{}}
                        fill="#f1f2f2"
                        data-original="#f1f2f2"
                    />
                </g>
            </svg>

        </>
    )
}

export default EmailVasIcon